<template>
  <gofr-element :edit="edit" :loading="false">
    <template #form>
      <v-text-field
        :error-messages="errors"
        @change="errors = []"
        :disabled="disabled"
        :label="$t(`App.fhir-resources-texts.${display}`)"
        v-model="value"
        outlined
        hide-details="auto"
        :rules="rules"
        :type="isPassword ? (showPassword ? 'text' : 'password') : 'text'"
        :append-icon="isHfid ? 'mdi-refresh' : (isPassword ? (showPassword ? 'mdi-eye' : 'mdi-eye-off') : '')"
        @click:append="isHfid ? generateHfid() : (showPassword = !showPassword)"
        :hint="isHfid && hfidDisplayFormat ? 'Display: ' + hfidDisplayFormat : ''"
        :persistent-hint="isHfid && !!hfidDisplayFormat"
        dense
      >
      <template #label>{{ $t(`App.fhir-resources-texts.${display}`) }}<span v-if="required" class="red--text font-weight-bold">*</span></template>
      </v-text-field>
    </template>
    <template #header>
      {{ $t(`App.fhir-resources-texts.${display}`) }}
    </template>
    <template #value>
      {{isHfid && value ? hfidDisplayFormat : value}}
    </template>
  </gofr-element>
</template>

<script>
import GofrElement from "../gofr/gofr-element.vue"
import { generateHfid, verifyHfid, formatHfidDisplay, parseHfidInput } from '@/plugins/hfid.js'

export default {
  name: "fhir-string",
  props: ["field", "label", "min", "max", "id", "path", "slotProps", "sliceName","base-min","base-max","edit","readOnlyIfSet",
    "constraints", "displayType"],
  components: {
    GofrElement
  },
  data: function() {
    return {
      source: { path: "", data: {} },
      value: "",
      showPassword: false,
      qField: "valueString",
      disabled: false,
      errors: [],
      lockWatch: false
    }
  },
  created: function() {
    // console.log("CREATE STRING",this.field,this.slotProps)
    this.setupData()
  },
  watch: {
    slotProps: {
      handler() {
        //console.log("WATCH STRING",this.field,this.path,this.slotProps)
        if ( !this.lockWatch ) {
          this.setupData()
        } else {
          this.ensureHfidValue()
        }
      },
      deep: true
    }
  },
  methods: {
    setupData() {
      if ( this.slotProps && this.slotProps.source ) {
        this.source = { path: this.slotProps.source.path+"."+this.field, data: {} }
        if ( this.slotProps.source.fromArray ) {
          this.source.data = this.slotProps.source.data
          this.value = this.source.data
          this.lockWatch = true
          //console.log("SET value to ", this.source.data, this.slotProps.input)
        } else {
          let expression = this.$fhirutils.pathFieldExpression( this.field )
          this.source.data = this.$fhirpath.evaluate( this.slotProps.source.data, expression )
          //console.log("STR FHIRPATH", this.slotProps.source.data, this.field)
          if ( this.source.data.length == 1 ) {
            this.value = this.source.data[0]
            this.lockWatch = true
          }
        }
        this.disabled = this.readOnlyIfSet && (!!this.value)
        //console.log(this.source)
      }
      this.ensureHfidValue()
    },
    generateHfid() {
      this.value = generateHfid()
    },
    ensureHfidValue() {
      if (!this.isHfid || this.value) {
        return
      }
      this.value = generateHfid()
    }
  },
  computed: {
    index: function() {
      if ( this.slotProps && this.slotProps.input ) return this.slotProps.input.index
      else return undefined
    },
    display: function() {
      if ( this.slotProps && this.slotProps.input) return this.slotProps.input.label
      else return this.label
    },
    required: function() {
      return (this.index || 0) < this.min
    },
    isHfid: function() {
      return (this.display || '').toUpperCase().includes('HFID')
    },
    hfidDisplayFormat: function() {
      if (!this.isHfid || !this.value) return ''
      const parsed = parseHfidInput(this.value)
      return parsed ? formatHfidDisplay(parsed) : ''
    },
    rules: function() {
      const rulesArr = []
      if (this.required) {
        rulesArr.push(v => !!v || this.display + ' is required')
      }
      if (this.isHfid) {
        rulesArr.push(v => {
          if (!v) return true
          const parsed = parseHfidInput(v)
          if (!parsed) return 'HFID must be a 6-digit number (optionally formatted as F-XXX-XXX)'
          return verifyHfid(parsed) || 'Invalid HFID — check digit does not match (Damm algorithm)'
        })
      }
      return rulesArr
    },
    isPassword: function() {
      return this.displayType === 'password'
    }
  }
}
</script>
